<template>
  <v-container v-if="getOrderIdentifier" class="grey lighten-4">
    <show-order :identifier="getOrderIdentifier"></show-order>
  </v-container>
</template>

<script>
import ShowOrder from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrder.vue";
export default {
  name: "CustomerOrderViewPage",
  components: {ShowOrder},
  mounted() {
    this.$store.dispatch('fetchCategories')
  },
  computed: {
    getOrderIdentifier() {
      return this.$route.params.identifier
    }
  }
}
</script>

<style scoped>

</style>
